import { createTheme, ThemeOptions } from "@mui/material/styles";

export const createThemeWithMode = (
  mode: "light" | "dark",
  muiLocale?: any,
  direction?: "ltr" | "rtl",
  fontFamily: string = "Roboto",
  primaryColor: string = "#1976d2",
  borderRadius: number = 14
) => {
  const themeOptions: ThemeOptions = {
    palette: {
      mode: mode,
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: "#f50057",
      },
    },
    shape: {
      borderRadius: borderRadius,
    },
    spacing: 8,
    breakpoints: {
      values: {
        xs: 0, // extra-small devices (portrait phones)
        sm: 600, // small devices (landscape phones)
        md: 900, // medium devices (tablets)
        lg: 1200, // large devices (desktops)
        xl: 1536, // extra-large devices (large desktops)
      },
    },
    typography: {
      fontFamily: fontFamily,
    },
    direction,
  };

  return createTheme(themeOptions, muiLocale);
};
